<template>
  <div class="footer-pages">
    <div class="container-fluid wrap">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4" v-if="includeInFooterRow1.length">
          <SfList>
            <SfListItem
              v-for="item in includeInFooterRow1"
              :key="item.SeName"
              :style="{ '--list-item-margin': '24px 0' }"
            >
              <router-link :to="`/p/${item.SeName}`" v-slot="{ href, route, navigate, isActive }">
                <SfMenuItem
                  :class="{ 'sf-menu-item--is-active': isActive }"
                  :style="{ 'text-align': 'left' }"
                  :label="item.Title"
                  @click="navigate"
                />
              </router-link>
            </SfListItem>
          </SfList>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4" v-if="includeInFooterRow2.length">
          <SfList>
            <SfListItem
              v-for="item in includeInFooterRow2"
              :key="item.SeName"
              :style="{ '--list-item-margin': '24px 0' }"
            >
              <router-link :to="`/p/${item.SeName}`" v-slot="{ href, route, navigate, isActive }">
                <SfMenuItem
                  :class="{ 'sf-menu-item--is-active': isActive }"
                  :style="{ 'text-align': 'left' }"
                  :label="item.Title"
                  @click="navigate"
                />
              </router-link>
            </SfListItem>
          </SfList>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4" v-if="includeInFooterRow3.length">
          <SfList>
            <SfListItem
              v-for="item in includeInFooterRow3"
              :key="item.SeName"
              :style="{ '--list-item-margin': '24px 0' }"
            >
              <router-link :to="`/p/${item.SeName}`" v-slot="{ href, route, navigate, isActive }">
                <SfMenuItem
                  :class="{ 'sf-menu-item--is-active': isActive }"
                  :label="item.Title"
                  @click="navigate"
                />
              </router-link>
            </SfListItem>
          </SfList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SfList, SfMenuItem } from '@storefront-ui/vue';
import pages from '../mixins/pages';

export default {
  name: 'FooterPages',
  components: {
    SfList,
    SfMenuItem,
  },
  mixins: [pages],
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";

.footer-pages {
  border-top: 1px solid var(--c-light);
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
